export default function ProductSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-pink-100 p-3 animate-pulse">
      <div className="w-full h-[160px] bg-pink-100 rounded-xl" />
      <div className="mt-3 h-3 bg-pink-100 rounded w-3/4 mx-auto" />
      <div className="mt-2 h-3 bg-pink-100 rounded w-1/3 mx-auto" />
    </div>
  );
}
